export default [
  // Main home page
  {
    path: "/care-nav",
    name: "care-nav",
    component: () => import("@/modules/care-nav/pages/CareNavHomePage.vue"),
    alias: "/care-nav/home"
  },

  // Care Nav Layout with nested routes
  {
    path: "/care-nav",
    component: () => import("@/modules/care-nav/layouts/CareNavLayouts.vue"),
    children: [
      // Medication Search
      {
        path: "/care-nav/medications",
        name: "care-nav-medications",
        component: () => import("@/modules/care-nav/pages/medications/MedicationSearch.vue")
      },
      {
        path: "/care-nav/labs",
        name: "care-nav-lab-tests",
        component: () => import("@/modules/care-nav/pages/lab-tests/LabTestSearch.vue")
      },
      {
        path: "/care-nav/lab-facilities",
        name: "care-nav-lab-facilities",
        component: () => import("@/modules/care-nav/pages/lab-facilities/LabFacilitiesSearch.vue")
      },
      {
        path: "/care-nav/plan-benefits",
        name: "care-nav-plan-benefits",
        component: () => import("@/modules/care-nav/pages/plan-benefits/PlanBenefitsPage.vue")
      },
      {
        path: "/care-nav/care-navigation",
        name: "care-nav-care-navigation",
        component: () => import("@/modules/care-nav/pages/care-navigation/CareNavigationSearch.vue")
      }
    ]
  },

  {
    path: "/coverage",
    name: "coverage",
    component: () => import("@/modules/care-nav/pages/CareNavHomePage.vue")
  },

  // Care Nav Layout with nested routes
  {
    path: "/coverage",
    component: () => import("@/modules/care-nav/layouts/CareNavLayouts.vue"),
    children: [
      // Medication Search
      {
        path: "/coverage/medications",
        name: "coverage-medications",
        component: () => import("@/modules/care-nav/pages/medications/MedicationSearch.vue")
      },
      {
        path: "/coverage/labs",
        name: "coverage-lab-tests",
        component: () => import("@/modules/care-nav/pages/lab-tests/LabTestSearch.vue")
      },
      {
        path: "/coverage/lab-facilities",
        name: "coverage-lab-facilities",
        component: () => import("@/modules/care-nav/pages/lab-facilities/LabFacilitiesSearch.vue")
      },
      {
        path: "/coverage/plan-benefits",
        name: "coverage-plan-benefits",
        component: () => import("@/modules/care-nav/pages/plan-benefits/PlanBenefitsPage.vue")
      },
      {
        path: "/coverage/care-navigation",
        name: "coverage-care-navigation",
        component: () => import("@/modules/care-nav/pages/care-navigation/CareNavigationSearch.vue")
      }
    ]
  },

  {
    path: "/coverage/:benefitPlanName",
    name: "coverage-details",
    props: true,
    component: () => import("@/modules/care-nav/pages/CareNavHomePage.vue")
  }
]
